module.exports = __webpack_public_path__ + "static/media/success-checked.1679f437.svg";